import { graphql } from 'services/api';
import { WhatsaapTemplate } from './types';
import * as queries from './queries';

const GET_WHATSAPP_TEMPLATE_LIMIT = 500;

export const getWhatsaapTemplates = async ({
  filter,
  organizationId
}: {
  filter: Record<string, string>;
  organizationId: string;
}): Promise<WhatsaapTemplate[]> => {
  const response = await graphql.query(
    queries.getWhatsaapTemplatesByOrganization,
    {
      organizationId,
      limit: GET_WHATSAPP_TEMPLATE_LIMIT,
      filter
    }
  );

  return response.getWhatsaapTemplatesByOrganization.items;
};

export const getWhatsaapTemplatesByOrganization = async ({
  organizationId,
  nextToken,
  filter
}: {
  organizationId: string;
  nextToken: string | null;
  filter?: Record<string, unknown>;
}): Promise<{ items: WhatsaapTemplate[]; nextToken: string }> => {
  const response = await graphql.query(
    queries.getWhatsaapTemplatesByOrganization,
    {
      organizationId,
      nextToken,
      sortDirection: 'DESC',
      limit: GET_WHATSAPP_TEMPLATE_LIMIT,
      filter
    }
  );

  return response.getWhatsaapTemplatesByOrganization;
};

export const getWhatsaapTemplate = async ({
  id
}: {
  id: string;
}): Promise<WhatsaapTemplate> => {
  const response = await graphql.query(queries.getWhatsaapTemplate, {
    id
  });

  return response.getWhatsaapTemplate;
};
